import {
    FETCH_CARS,
    FETCH_CLIENTS,
    FETCH_MODEL_BRAND,
    FETCH_ORDERS,
    HIDE_ALERT,
    HIDE_LOADER,
    SET_ORDERS_STATISTICS,
    SET_ORDER_ID,
    SET_ORDER_LINK,
    SHOW_ALERT,
    SHOW_LOADER,
    TOGGLE_TRUE_LOGGED_CLIENT,
    SET_TOP_CLIENTS,
    SET_RENT_START_DATE,
    SET_RENT_END_DATE,
    FETCH_TG_CLIENTS,
    SET_STATISTICS_ALLDAY,
    INVALID_TOKEN,
    SET_EXTENDED_ORDER,
    SET_CAR_PAGINATION_DATA,
    SET_CLIENT_PAGINATION_DATA,
    SET_ORDER_PAGINATION_DATA
} from "./types";
import axios from "axios";

const localStorageToken = 'userData'
const newCreatedUserData = 'newCreatedUserData'

export function showLoader() {
    return {
        type: SHOW_LOADER
    }
}
export function hideLoader() {
    return {
        type: HIDE_LOADER
    }
}
export function invalidToken() {
    return {
        type: INVALID_TOKEN
    }
}
export function clearAllData() {
    return dispatch => {
        dispatch({type: FETCH_CARS, payload: []})
        dispatch({type: FETCH_MODEL_BRAND, payload: []})
        dispatch({type: FETCH_CLIENTS, payload: []})
        dispatch({type: FETCH_ORDERS, payload: []})
        dispatch({type: SET_ORDERS_STATISTICS, payload: []})
        dispatch({type: SET_TOP_CLIENTS, payload: []})
    }
}
export function showAlert(text, type = 'info') {
    return dispatch => {
        dispatch({
            type: SHOW_ALERT,
            payload: {text, type}
        })

        setTimeout(() => {
            dispatch(hideAlert())
        }, 3000)
    }
}
export function hideAlert() {
    return {
        type: HIDE_ALERT
    }
}
export function createCar(formData) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            for (let value of formData.values()) {
                console.log(value);
            }
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.post(`https://rezilizer.ru/api/cars/`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Token ${token.token}`
                }
            }).then((res) => {
                if (res.status === 201) {
                    dispatch(showAlert(`${res.data.brand} ${res.data.model} has successfully been added`, 'success'))
                    dispatch(fetchCars())
                }
            }).catch(() => dispatch(showAlert('Could not add car', 'danger')))
            dispatch(hideLoader())
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
            dispatch(showAlert('You did not upload a picture!', 'danger'))
            dispatch(hideLoader())
        }
    }
}
export function reserveVehicle(rentData) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            console.log(rentData)
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.post(`https://rezilizer.ru/api/orders/`, {...rentData}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            }).then((res) => {
                if (res.status === 201) {
                    dispatch(showAlert(`You have reserved ${res.data.brand} ${res.data.model}`, 'info'))
                }
            }).catch((e) => console.log(e))
            dispatch(fetchCars())
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function getDocumentFromServer(orderId, extended) {
    return async dispatch => {
        try {
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            let requestUrl
            if (extended) {
                console.log('exteded rde')
                requestUrl = `https://rezilizer.ru/api/getfile?extended_order_id=${orderId}`
            } else {
                console.log('norm')
                requestUrl = `https://rezilizer.ru/api/getfile?order_id=${orderId}`
            }
            await axios.get(requestUrl, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
                data: {
                    order_id: `${orderId}`
                }
            }).then((res) => {
                dispatch({type: SET_ORDER_LINK, payload: res.data.document})
            })
        } catch (e) {
            console.log(e)
        }
    }
}
export function rentVehicle(rentData) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.post(`https://rezilizer.ru/api/orders/`, {...rentData}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
            }).then((res) => {
                if (res.status === 201) {
                    dispatch({type: SET_ORDER_ID, payload: res.data.order_id})
                    let currentClient = JSON.parse(localStorage.getItem(`newCreatedUserData`))
                    currentClient.newUserStatus = "occupied"
                    localStorage.setItem(`newCreatedUserData`, JSON.stringify(currentClient))
                    dispatch(getDocumentFromServer(res.data.order_id))
                    dispatch({type: SET_RENT_START_DATE, payload: ''})
                    dispatch({type: SET_RENT_END_DATE, payload: ''})
                    dispatch(showAlert(`You have successfully rented ${res.data.brand} ${res.data.model}.`, 'success'))
                }
            }).catch((e) => console.log(e))
            dispatch(fetchCars())
            dispatch(hideLoader())
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function checkClient(passport) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            if (!passport.length) {
                dispatch(showAlert('Input field cannot be empty!', 'danger'))
                dispatch(hideLoader())
                return
            }
            const requestingUrl = `https://rezilizer.ru/api/clients?search=${passport}`
            const existingUser = await axios.get(`${requestingUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            dispatch(hideLoader())
            if (!existingUser.data.length) {
                dispatch(showAlert('User not found!', 'danger'))
                return
            }
            if (passport.length && existingUser.data.length) {
                console.log(existingUser.data)
                localStorage.setItem(newCreatedUserData, JSON.stringify({
                    newUserId: existingUser.data[0].client_id,
                    newUserName: existingUser.data[0].firstname,
                    newUserSurname: existingUser.data[0].lastname,
                    newUserStatus: existingUser.data[0].status,
                }))
                dispatch(showAlert(`You have logged in as ${existingUser.data[0].firstname} ${existingUser.data[0].lastname}`, 'success'))
                dispatch({type: TOGGLE_TRUE_LOGGED_CLIENT})
            }
        } catch (e) {
            dispatch(showAlert('Something went wrong', 'danger'))
        }
    }
}
export function createClient(formData) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.post(`https://rezilizer.ru/api/clients/`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Token ${token.token}`
                },
            }).then((res) => {
                if (res.data) {
                    localStorage.setItem(newCreatedUserData, JSON.stringify({
                        newUserId: res.data.client_id
                    }))
                }
                if (res.status === 201) {
                    dispatch(showAlert('User successfully created!', 'success'))
                }
            })
                .catch((e) => showAlert(e, 'danger'))
            dispatch(hideLoader())
        } catch (e) {
            console.log(e)
            dispatch(showAlert('User is not created!', 'danger'))
            dispatch(hideLoader())
        }
    }
}
export function fetchCars(currentFilter = null, nextPage = null) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            let requestUrl = `https://rezilizer.ru/api/cars/`
            if (!!nextPage) {
                requestUrl = nextPage
            }
            const response = await axios.get(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            })
            if (currentFilter) {
                console.log(response.data.results)
                const filteredArray = []
                response.data.results.map(car => {
                    if (!currentFilter.price && !currentFilter.brand || currentFilter.brand === "Select a brand") {
                        if (car.color === currentFilter.color)
                            return filteredArray.push(car);
                    } else if (currentFilter.brand === car.brand) {
                        if (
                            currentFilter.model === null ||
                            currentFilter.model === "Select a model" ||
                            car.model === currentFilter.model
                        ) {
                            if (currentFilter.color === car.color || !currentFilter.color)
                                return filteredArray.push(car)
                        } else if (car.model === currentFilter.model) {
                            if (car.rent_cost <= currentFilter.price) {
                                return filteredArray.push(car);
                            } else if (!currentFilter.price) {
                                return filteredArray.push(car);
                            }
                        } else {}
                    }
                })
                dispatch(hideLoader())
                const sortedArrayOfCars = filteredArray.sort((a, b) => {
                    let x = a.status.toLowerCase()
                    let y = b.status.toLowerCase()
                    if (x < y) {return 1}
                    if (x > y) {return -1}
                })
                console.log(sortedArrayOfCars)
                return dispatch({type: FETCH_CARS, payload: sortedArrayOfCars})
            }
            const sortedArrayOfCars = response.data.results.sort((a, b) => {
                let x = a.status.toLowerCase()
                let y = b.status.toLowerCase()
                if (x < y) {return 1}
                if (x > y) {return -1}
            })
            // delete results key before passing to a payload
            delete response.data.results
            dispatch({type: FETCH_CARS, payload: sortedArrayOfCars})
            dispatch({type: SET_CAR_PAGINATION_DATA, payload: response.data})
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function fetchModelBrand() {
    return async dispatch => {
        try {
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const response = await axios.get(`https://rezilizer.ru/api/brand&model/`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            })
            dispatch({type: FETCH_MODEL_BRAND, payload: response.data})
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function fetchClients(passportData, nextPage = null) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            let requestUrl = null
            if (passportData) {
                requestUrl = `https://rezilizer.ru/api/clients?search=${passportData}`
            } else if (!!nextPage) {
                requestUrl = nextPage
            } else {
                requestUrl = `https://rezilizer.ru/api/clients/`
            }
            const response = await axios.get(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            })
            // sort to set black list users to the end
            let sortedArrayOfClients = []
            sortedArrayOfClients = response.data.results.sort((a, b) => {
                let x = a.black_list
                let y = b.black_list
                if (x == y) {
                    return -1
                } else {
                    return 1
                }
            })
            console.log('resetting')
            if (!!passportData) {
                sortedArrayOfClients = response.data[0]
            }
            console.log(response.data)
            delete response.data.results
            dispatch({type: FETCH_CLIENTS, payload: sortedArrayOfClients.reverse()})
            dispatch({type: SET_CLIENT_PAGINATION_DATA, payload: response.data})
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function updateOrder(id, edited) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/orders/${id}/`
            await axios.put(`${requestUrl}`, {...edited}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
            }).then(res => {
                if (res.status === 200) {
                    dispatch(showAlert(`You stopped the order`, `info`))
                }
            })
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchOrders())
            dispatch(hideLoader())
        }
    }
}
export function fetchExtendedOrder(id) {
    return async dispatch => {
        try {
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/extended_order/?order_id=${id}`
            const response = await axios.get(requestUrl, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            })
            dispatch({type: SET_EXTENDED_ORDER, payload: response.data})
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        }
    }
}
export function orderProlong(id, edited) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const response = await axios({
                method: 'post',
                url: 'https://rezilizer.ru/api/extended_order/',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${token.token}`
                },
                data: {
                    ...edited // This is the body part
                }
            })
            console.log('server responded' + response)
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchOrders())
            dispatch(hideLoader())
        }
    }
}
export function fetchOrders(nextPage = null) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            let requestUrl = `https://rezilizer.ru/api/orders/`
            if (!!nextPage) {
                requestUrl = nextPage
            }
            const response = await axios.get(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            })
            console.log(response)
            dispatch({type: FETCH_ORDERS, payload: response.data.results})
            delete response.data.results
            dispatch({type: SET_ORDER_PAGINATION_DATA, payload: response.data})
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function updateCar(id, edited) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/cars/${id}/`
            await axios.put(`${requestUrl}`, {...edited}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
            }).then(res => {
                if (res.status === 200) {
                    dispatch(showAlert(`Successfully changed!`, `success`))
                }
            })
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchCars())
            dispatch(hideLoader())
        }
    }
}
export function addClientToBlackList(id, message) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            console.log(message)
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/black_list/`
            const response = await axios.post(`${requestUrl}`, {...message}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            if (response.status === 200) {
                dispatch(showAlert(`User is now in a black list!`, `info`))
            }
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchClients())
            dispatch(hideLoader())
        }
    }
}
export function removeClientFromBlackList(id) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/black_list/${id}`
            const response = await axios.delete(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            if (response.status === 204) {
                dispatch(showAlert(`You have removed user from a black list!`, `warning`))
            }
            if (response.status === 405) {
                dispatch(showAlert(`You cannot remove this user from a black list!`, `warning`))
            }
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
                dispatch(showAlert(`Could not remove from a black list`, 'danger'))
            } catch (e) {

            }
        } finally {
            dispatch(fetchClients())
            dispatch(hideLoader())
        }
    }
}
export function updateClient(id, edited) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/clients/${id}/`
            await axios.put(`${requestUrl}`, {...edited}, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
            }).then(res => {
                if (res.status === 200) {
                    dispatch(showAlert(`Successfully changed!`, `success`))
                }
            })
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchClients())
            dispatch(hideLoader())
        }
    }
}
export function fetchTelegramClients() {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.get(`https://rezilizer.ru/api/clients_tg/`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                },
            }).then(res => {
                dispatch({type: FETCH_TG_CLIENTS, payload: res.data})
            })
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function acceptTgClient(id) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/clients_tg/${id}/?answer=confirmed`
            await axios.delete(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            }).then(() => dispatch(showAlert(`User has successfully been added!`, `success`)))
                .catch(e => dispatch(showAlert(`Could not add user!`, `danger`)))
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchTelegramClients())
            dispatch(hideLoader())
        }
    }
}
export function declineTgClient(id, message) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            console.log(message)
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const requestUrl = `https://rezilizer.ru/api/clients_tg/${id}/`
            await axios.delete(`${requestUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
                data: {
                    Response: `${message.message}`
                },
            }).then(() => dispatch(showAlert(`Message has been sent to user`, `info`)))
                .catch(e => dispatch(showAlert(`Could not send message to user!`, `danger`)))
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(fetchTelegramClients())
            dispatch(hideLoader())
        }
    }
}
export function fetchGraphOne() {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.get(`https://rezilizer.ru/api/analytics/car_cashflow`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            }).then(res => {
                dispatch({type: SET_ORDERS_STATISTICS, payload: res.data})
            })
        } catch(e){
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function fetchGraphTwo() {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))

            await axios.get(`https://rezilizer.ru/api/analytics/top_clients`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            }).then(res => {
                dispatch({type: SET_TOP_CLIENTS, payload: res.data})
            })
        } catch(e){
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function fetchGraphThree(requestingUrl) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            await axios.get(`${requestingUrl}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`,
                },
            }).then(res => {
                dispatch({type: SET_STATISTICS_ALLDAY, payload: res.data})
            })
        } catch(e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
        }
    }
}
export function deleteVehicle(id) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const response = await axios.delete(`https://rezilizer.ru/api/cars/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            if (response.status === 204) {
                dispatch(showAlert(`You have deleted a car`, 'info'))
            }
        } catch (e) {
            try {
                if (e.response.status === 405) {
                    dispatch(showAlert(`This car currently is being rented`, 'warning'))
                }
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
            dispatch(fetchCars())
            dispatch(fetchModelBrand())
        }

    }
}
export function deleteClient(id) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const response = await axios.delete(`https://rezilizer.ru/api/clients/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            if (response.status === 204) {
                dispatch(showAlert(`You have deleted a client`, 'info'))
            }
        } catch (e) {
            try {
                if (e.response.status === 405) {
                    dispatch(showAlert(`This user currently is renting a car`, 'warning'))
                }
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
            dispatch(fetchClients())
        }

    }
}
export function deleteOrder(id) {
    return async dispatch => {
        try {
            dispatch(showLoader())
            const token = await JSON.parse(localStorage.getItem(localStorageToken))
            const response = await axios.delete(`https://rezilizer.ru/api/orders/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token.token}`
                }
            })
            if (response.status === 204) {
                dispatch(showAlert(`You have deleted an order`, 'info'))
            }
        } catch (e) {
            try {
                if (e.response.status === 401) {
                    dispatch(invalidToken())
                    dispatch(showAlert('Your token has expired', 'danger'))
                }
            } catch (e) {

            }
        } finally {
            dispatch(hideLoader())
            dispatch(fetchOrders())
        }

    }
}
